import { render, staticRenderFns } from "./iconssocial.vue?vue&type=template&id=760a307e"
import script from "./iconssocial.vue?vue&type=script&lang=js"
export * from "./iconssocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports